import React, { FC } from 'react';
import styled from '@emotion/styled';
import { colors } from '@modernhealth/vital-foundation';
import { HeadingText50 } from '@modernhealth/vital-components';

import { color } from 'src/shared/styles/variables';
import { CoachNode } from 'src/generated/webapp_gql';

type Props = {
    provider: Pick<CoachNode, 'firstName' | 'lastName' | 'avatar'>;
};

export const SessionReviewProviderAvatar: FC<Props> = ({ provider }) => {
    const { avatar, firstName, lastName } = provider;

    if (avatar) {
        return <Avatar src={avatar} />;
    }

    return (
        <AvatarPlaceholder>
            <Initials>
                {firstName?.[0]}
                {lastName?.[0]}
            </Initials>
        </AvatarPlaceholder>
    );
};

const Avatar = styled.img({
    width: 170,
    height: 170,
    borderRadius: '50%',
    display: 'block',
    objectFit: 'cover',
    objectPosition: 'top center',
    margin: '0 auto',
});

const AvatarPlaceholder = styled(Avatar.withComponent('div'))({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: color.cornflowerBlue,
});

const Initials = styled(HeadingText50)({
    color: colors.white,
    margin: '0px !important', // important to override default marginBottom
});
